import Button from '../../../components/Button';
import i18n from '../../../translations/i18n';
interface BackButtonProps {
    doStepBack: () => void;
    currentStep: number;
    disabled?: boolean;
}
export const BackButton = ({ doStepBack, currentStep, disabled = false }: BackButtonProps) => {
    return (<Button disabled={currentStep === 0 || disabled} onClick={doStepBack} variant='outlined' fullWidth>
      {i18n.t('general.back')}
    </Button>);
};
